import * as Yup from 'yup';
import { v4 as uuidV4 } from 'uuid';
import { IOptionType } from '@zz2/zz2-ui';
import { IPack } from '../pack/pack';
import { ISize } from './size';
import { ISizeFormValues } from './sizeFormValues';
import { ISizeUpsert } from './sizeUpsert';

export default class SizeModelHelper {
    public static createFormValues = (
        size : ISize | null,
        packs : Array<IPack>
    ) : ISizeFormValues => {
        if (!size) return {
            id: 0,
            guid: uuidV4(),
            code: '',
            name: '',
            packs: [],
            isActive: true,
        };

        const packOptions = packs.filter(x => size.packIds.includes(x.id))
            .map((x) => { // TODO: OptionType.FromDataModel
                return {
                    label: `(${x.code}) - ${x.description}`,
                    value: x.id
                };
            });

        return {
            id: size.id,
            guid: size.guid,
            code: size.code,
            name: size.name,
            packs: packOptions,
            isActive: size.isActive,
        };
    };

    public static createUpsert = (formValues : ISizeFormValues) : ISizeUpsert => {
        return {
            id: formValues.id,
            guid: formValues.guid,
            code: formValues.code,
            name: formValues.name,
            packIds: formValues.packs.map(x => Number(x.value)),
            isActive: formValues.isActive,
        };
    };

    public static formSchema = () : Yup.ObjectSchema<ISizeFormValues> => Yup.object().shape({
        id: Yup.number().typeError('Please enter a number.').required('Required'),
        guid: Yup.string().required('Required'),
        code: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        name: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        packs: Yup.array<IOptionType>().defined().required('Required'),
        isActive: Yup.boolean().required('Required'),
    });
}
